import Mode from '../lib/consts';
const GetCookieDomain = () => {
    let host = location.hostname;
    /* eslint max-len: ["error", { "code": 180 }] */
    const ip = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
    if (ip.test(host) === true || host === 'localhost') return host;
    const regex = /([^]*).*/;
    const match = host.match(regex);
    if (typeof match !== 'undefined' && match !== null) {
        host = match[1];
    }
    if (typeof host !== 'undefined' && host !== null) {
        const strAry = host.split('.');
        if (strAry.length > 1) {
            // host = strAry[strAry.length - 2] + '.' + strAry[strAry.length - 1];
            host = `${strAry[strAry.length - 2]}.${strAry[strAry.length - 1]}`;
        }
    }
    return `.${host}`;
};

const getParameterByName = name => {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    // const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1]);
};

const blobToDataURL = (blob, callback) => {
    const a = new FileReader();
    a.onload = function (e) {
        callback(e.target.result);
    };
    a.readAsDataURL(blob);
};

const dataURLtoBlob = dataurl => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length - 1;
    const u8arr = new Uint8Array(n);
    while (n >= 0) {
        u8arr[n] = bstr.charCodeAt(n);
        n--;
    }
    return new Blob([u8arr], {type: mime});
};

const removeUrlProtocal = url => {
    if (!url) {
        return url;
    }
    ['http:', 'https:'].forEach(protocal => {
        if (url.indexOf(protocal) === 0) {
            url = url.replace(protocal, '');
        }
    });
    return url;
};
const getLocationProtocol = () => location.protocol;

const formatTime = date => {
    const Y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    let H = date.getHours();
    let i = date.getMinutes();
    let s = date.getSeconds();
    m < 10 ? m = `0${m}` : m;
    d < 10 ? d = `0${d}` : d;
    H < 10 ? H = `0${H}` : H;
    i < 10 ? i = `0${i}` : i;
    s < 10 ? s = `0${s}` : s;
    const time = `${Y}-${m}-${d} ${H}:${i}:${s}`;
    return time;
};
const getImgWidthAndHeight = (file)=>{
    return new Promise((resolve,reject)=>{
        const img = new Image();
        const obJUrl = URL.createObjectURL(file);
        img.onload = function(){
            //释放objUrl
            URL.revokeObjectURL(obJUrl);
            resolve({width:this.width,height:this.height});
        };
        img.src = obJUrl;
    });
};

const getIsValidImgWidthAndHeight = (width,height)=>{
    //unity3d团队说要限制图片宽高要被4整除
    return (width % 4 === 0 && height % 4 === 0);
};

// 图片的宽高是否在限制范围内
const isImageSizeWithinLimits = (width, height) => {
    const STAGE_WIDTH = 480;
    const STAGE_HEIGHT = 360;
    return width <= STAGE_WIDTH && height <= STAGE_WIDTH && (width <= STAGE_HEIGHT || height <= STAGE_HEIGHT);
};

const getModeByUrl = (url)=>{
    const urlSearchParams = new URLSearchParams(url);
    const mode = urlSearchParams.get('mode');
    if(mode === null){
        return Mode.STUDENT;
    }
    return mode;
};

const getIsTeacherMode = ()=>{
    return getModeByUrl(location.search) === Mode.TEACHER
};

export {
    GetCookieDomain,
    getParameterByName,
    blobToDataURL,
    dataURLtoBlob,
    formatTime,
    getLocationProtocol,
    removeUrlProtocal,
    getImgWidthAndHeight,
    getIsValidImgWidthAndHeight,
    isImageSizeWithinLimits,
    getIsTeacherMode
};
